import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, InputSignal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { ImageComponent } from '@libs/common/components';
import { ContentTeaserItemModel, HeadlinesItemModel, LinkItemModel } from '@libs/cms/models';
import {
  PageBlockImpressionDirective,
  PageBlockLinkClickDirective,
  provideContentTrackingData,
} from '@libs/shared/tracking';
import { ContentLinkDirective } from '@libs/shared/ui';
import { HeadlinesComponent } from '../headlines';

@Component({
  selector: 'ui-content-teaser',
  templateUrl: './content-teaser.component.html',
  styleUrls: ['./content-teaser.component.scss'],
  imports: [
    ImageComponent,
    HeadlinesComponent,
    MatCardModule,
    MatButtonModule,
    MatRippleModule,
    NgTemplateOutlet,
    ContentLinkDirective,
    PageBlockImpressionDirective,
    PageBlockLinkClickDirective,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    provideContentTrackingData(ContentTeaserComponent),
  ],
})
export class ContentTeaserComponent {
  public readonly data: InputSignal<ContentTeaserItemModel> = input.required();

  public readonly dataView: Signal<ContentTeaserItemModel> = computed(() => ({
    type: 'contentTeaser',
    image: this.data().image,
    name: this.data().name,
    headlines: this.getHeadlines(),
    link: this.getLink(),
  }));

  private getHeadlines(): HeadlinesItemModel | undefined {
    const item: HeadlinesItemModel | undefined = this.data().headlines;
    const isEmpty: boolean = !item?.headline && !item?.subline && !item?.tagline && !item?.bodyCopy;

    return isEmpty ? undefined : item;
  }

  private getLink(): LinkItemModel | undefined {
    const link: LinkItemModel | undefined = this.data().link;

    return link?.href ? link : undefined;
  }
}
